import styled from 'styled-components';

import { Dialog, Text12, Text18SB } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const DialogStyled = styled(Dialog)`
  width: 460px;
`;

export const DialogContent = styled(Dialog.Content)``;

export const Title = styled(Text18SB)``;

export const Description = styled(Text12)`
  margin-top: 8px;
  color: ${ct({ Dark: Colors.Dark, Light: Colors.Dark })};
`;
